import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const TaskTemplateDialogTourConfig: AgTechTourConfig = {
    id: 'task-template-dialog-tour',
    name: 'Task Template Tour',
    steps: [
        {
            targetId: 'task-template-name',
            title: 'Template Name',
            description: 'Name the template after the kind of sale it supports, for example Sale Preparation Checklist.',
            position: 'bottom',
        },
        {
            targetId: 'task-template-description',
            title: 'Description',
            description: 'Optionally explain when to use this template.',
            position: 'bottom',
        },
        {
            targetId: 'task-template-items',
            title: 'Template Items',
            description: 'Each item becomes a planning task when the template is applied. Items are scheduled relative to the sale start date. Add, edit or delete items here; everything is saved together when you submit the template.',
            position: 'top',
        },
    ]
}
